import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { getTerminalPackagesCode, getTerminalPackagesCodeResponse } from "./TerminalManagementData/GetTerminalPackagesCode";

const languageMap = {
    curl: 'bash',
    java: 'java',
    "C#": 'csharp',
    python: 'python',
    JavaScript: 'javascript'
};

const GetTerminalPackagesComponent = () => {
    const [selectedLanguageGetTerminalPackages, setSelectedLanguageGetTerminalPackages] = useState('curl');
    const [copyStatus, setCopyStatus] = useState({ type: '', isCopied: false });

    const handleSelectedCode = (language) => {
        setSelectedLanguageGetTerminalPackages(language);
    };

    const handleCopyClick = (type) => {
        const textToCopy = type === 'getTerminalPackages' ? getTerminalPackagesCode[selectedLanguageGetTerminalPackages].request : getTerminalPackagesCodeResponse;
        navigator.clipboard.writeText(textToCopy)
        .then(() => {
            setCopyStatus({ type, isCopied: true });
            setTimeout(() => {
                setCopyStatus({ type: '', isCopied: false });
            }, 1000);
        })
        .catch((error) => {
            console.error('Error copying text: ', error);
            alert('Failed to copy text. Please try again.');
        });
};

return (
    <section className="docs-section" id="terminal-packages">
                <div className="row flexbox">
                    <div className="col-md-5">
                        <h2 className="section-heading">Get Terminal Packages</h2>
                        <p><span className="badge badge-secondary back-green">POST</span><span className="api"> /terminal/getPackages/{'{customerId}'}/{'{model}'}</span></p>
                        <p>Returns all the available terminal update packages linked for the specified customerId and model. Please make sure customerId and model are path variable should be append to the request.</p>

                        <div className="response-codes">
                            <div className="table-wrapper">
                                <h6 className="header">Available terminal models</h6>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>C10</td>
                                            <td>Our desktop terminal without a printer</td>
                                        </tr>
                                        <tr>
                                            <td>C100</td>
                                            <td>Our mobile terminal that can be used in any application.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />

                        <h4>Path Parameters</h4>

                        <div className="property-tab col-md-10 border-bottom">
                            <p required><span className="badge badge-secondary name">customerId</span> &nbsp; &nbsp; <b>number</b></p>
                            <p className="description">Customer ID - Identifies the customer within the Access system. <br />
                                This id can be found in the URL of each customer that you have access to. <i>/OnBoarding/ModifyCustomer?id=%</i></p>
                        </div>
                        <div className="property-tab col-md-10 border-bottom">
                            <p required><span className="badge badge-secondary name">model</span> &nbsp; &nbsp; <b>string</b></p>
                            <p className="description">Terminal model (C10 or C100)</p></div>
                        <br />

                        <div className="response-codes">

                            <h4>Response Codes</h4>

                            <div className="table-wrapper">

                                <h6 className="header">HTTP Status code summary</h6>

                                <table>
                                    <tbody>
                                        <tr>
                                            <td>200 Success</td>
                                            <td>Get terminalid request was successful.</td>
                                        </tr>
                                        <tr>
                                            <td>400 Bad Request</td>
                                            <td>Bad request format or validation failed for incorrect data formats.</td>
                                        </tr>
                                        <tr>
                                            <td>401 Unauthorized</td>
                                            <td>Request requires authentication, and the provided credentials are either missing, invalid, or insufficient, hence send a valid merchant access token (Bearer) issued by Westpay in the "Authorization" header.</td>
                                        </tr>
                                        <tr>
                                            <td>404 Resources not found</td>
                                            <td>If request cannot find data for provided data.</td>
                                        </tr>
                                        <tr>
                                            <td>422 Unprocessable entity</td>
                                            <td>Indicates that the server understands the request but cannot process it due to semantic errors or invalid data in the request payload.</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>

                    </div>

                    <div className="col-md-7 code-segments">
                    <div className="docs-code-block">
                    <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Request</span>
                                        {Object.keys(getTerminalPackagesCode).map(language => (
                                            <React.Fragment key={language}>
                                                <input type="radio" name="langGetTerminalPackages" id={`${language}GetTerminalPackages`} onClick={() => handleSelectedCode(language)} checked={selectedLanguageGetTerminalPackages === language} />
                                                <label htmlFor={`${language}GetTerminalPackages`} className="language">{language}</label>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'getTerminalPackages' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("getTerminalPackages")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'getTerminalPackages' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language={languageMap[selectedLanguageGetTerminalPackages]} style={dracula} showLineNumbers>
                                        {getTerminalPackagesCode[selectedLanguageGetTerminalPackages].request}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                    <div className="docs-code-block">
                    <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Response</span>
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'getTerminalPackagesResponse' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("getTerminalPackagesResponse")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'getTerminalPackagesResponse' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language="json" style={dracula} showLineNumbers>
                                        {getTerminalPackagesCodeResponse}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                </div>


    </div>
        </section>
    );
};

export default GetTerminalPackagesComponent;